import { datadogRum } from "@datadog/browser-rum";

// Track only certain paths to reduce noise and cost
// Add something here if you want it tracked
const paths_to_track = [
	/^\/$/,
	/^\/dashboard\/?$/,
	/^\/supply\/?$/,
	/^\/demand\/?$/,
	/^\/supply\/new\/?$/,
	/^\/connected_supply\/new\/?$/,
	/^\/programmatic_guaranteed\/new\/?$/,
	/^\/demand\/new\/?$/,
	/^\/demand\/\d+\/?$/,
	/^\/demand\/\d+\/duplicate\/?$/,
	/^\/demand\/direct_io\/new\/?$/,
	/^\/demand\/dsp_connect\/new\/?$/,
	/^\/demand\/dsp_connect\/\d+\/?$/,
	/^\/demand\/dsp_connect\/\d+\/duplicate\/?$/,
	/^\/supply\/\d+\/?$/,
	/^\/supply\/\d+\/duplicate\/?$/,
	/^\/ad_quality\/?$/,
	/^\/ad_quality\/scanned_creatives\/?$/,
	/^\/ad_quality\/scanned_creatives\/\d+\/?$/,
	/^\/ad_quality\/scanned_creative_lists\/?$/,
	/^\/ad_quality\/scanned_creative_lists\/\d+\/?$/,
	/^\/ad_quality\/scanned_creative_lists\/new\/?$/,
	/^\/ad_quality\/scanned_creative_lists\/\d+\/duplicate\/?$/,
	/^\/ad_quality\/scanned_creative_lists\/\d+\/edit\/?$/,
	/^\/accounts\/?$/,
	/^\/accounts\/\d+\/?$/,
	/^\/supply\/clearline_deals\/?$/,
];

function isTrackablePath(path) {
	return paths_to_track.some((regex) => regex.test(path));
}

function isTrackableView() {
	return window.__ddRumInitialized && isNewView();
}

function isNewView() {
	return window.__ddLastViewName !== currentViewName();
}

function currentViewName() {
	let path = window.location.pathname;
	path = path.replace(/\/\d+(\/|$)/gm, '/:id$1');
	const hash = window.location.hash;
	return hash ? path + hash : path;
}

function willTrack() {
	const path = window.location.pathname;
	if (isTrackablePath(path) && isTrackableView()) {
		let viewName = currentViewName();
		window.__ddLastViewName = viewName;
		datadogRum.startView(viewName);
		if (window.__dd_rum_development === true) {
			console.info(`DD RUM: Tracking view ${viewName}`);
		}
	}
}

function isStreamserve() {
	const streamserveCookie = document.cookie.split('; ').find(cookie => cookie.startsWith('x_is_in_streamserve_frame='));
	return streamserveCookie ? streamserveCookie.split('=')[1] === 'true' : false;
}

function getEnv() {
	const vdConfig = window.__vd_config || {};
	const env = vdConfig.environment || 'development';
	const whiteLabelName = vdConfig.whiteLabelPlatformName.replace(' ', '_') || '';
	
	const parts = [env];
	if (isStreamserve()) {
		parts.push('streamserve');
	} else if (whiteLabelName) {
		parts.push(whiteLabelName.toLowerCase());
	}
	
	return parts.join(':');
}

function getShouldRun() {
	const vdConfig = window.__vd_config || {};
	const env = vdConfig.environment || 'development';
	const shouldRun = env === 'staging' || env === 'production';
	const envIsOverridden = (window.__dd_rum_development === true) || window.localStorage.getItem("dd_rum_development") === "true";
	
	return { env, shouldRun, envIsOverridden };
}

function setUserInfo() {
	const vdConfig = window.__vd_config || {};
	const userId = vdConfig.userId;
	const userAccount = vdConfig.userAccount;
	const userRole = vdConfig.userRole;
	
	if (userId) {
		datadogRum.setUser({ id: userId });
		if (window.__dd_rum_development === true) {
			console.info(`DD_RUM: Setting user id ${userId}`);
		}
	}
	if (userAccount) {
		datadogRum.setGlobalContextProperty("account", userAccount);
		if (window.__dd_rum_development === true) {
			console.info(`DD_RUM: Setting user account ${userAccount}`);
		}
	}
	if (userRole) {
		datadogRum.setGlobalContextProperty("role", userRole);
		if (window.__dd_rum_development === true) {
			console.info(`DD_RUM: Setting user role ${userRole}`);
		}
	}
}

function getVersion() {
	const version = 'release-0717-171008'
	if (/^[0-9a-f]{7,12}$/.test(version)) {
		return version;
	}
	return 'master';
}

function init() {
	// Check if DD RUM should run based on environment from window.__vd_config
	// Runs in staging/production, false for development/candidate
	// To override for testing, see dd_rum_ctrl below
	const { env, shouldRun, envIsOverridden } = getShouldRun();
	
	if (window.__dd_rum_development === true) {
		console.info(`DD_RUM: shouldRun=${shouldRun}, environment="${env}"`);
	}
	
	// If we shouldn't run and there's no override, return early
	if (!shouldRun && !envIsOverridden) return;

	// guard against initing multiple ddRum instances
	if (window.__ddRumBootstrapped) return;
	window.__ddRumBootstrapped = true;

	datadogRum.init({
		applicationId: "9544ecb4-4e37-4f79-9a3f-c07a4120ffb7",
		clientToken: "pub0319466eecb91ecadbe5a1fdaf0eb450",
		// `site` refers to the Datadog site parameter of your organization
		// see https://docs.datadoghq.com/getting_started/site/
		site: "datadoghq.com",
		service: "springserve-vd-ui-rum",
		env: getEnv(),
		sessionSampleRate: 100,
		sessionReplaySampleRate: 5,
		trackBfcacheViews: true,
		trackViewsManually: true,
		defaultPrivacyLevel: "mask-user-input",
		enableExperimentalFeatures: ["feature_flags"],
		version: getVersion(),
		beforeSend: (event) => {
			if (event.type === "resource" && event.resource.type === "media" && window.location.pathname.startsWith("/ad_quality/scanned_creatives/")) {
				return false;
			}
			return true;
		},
	});
	window.__ddRumInitialized = true; // guard against trying to fire events before ddRum is ready

	document.addEventListener("turbo:load", willTrack); // Track on turbo partial loads
	window.addEventListener("hashchange", willTrack); // Track on hash navigations
	setUserInfo();
	willTrack(); //capture initial page view
}
window.__dd_rum_init = init;

init();

/*
Use this to control for development. In the console, run:
	dd_rum_ctrl.enable()  - to enable logging and override env checks
	dd_rum_ctrl.disable() - to disable logging and enforce env checks
	dd_rum_ctrl.status()  - to see current status
	dd_rum_ctrl.track()   - to manually trigger a track event (if applicable)
*/
window.dd_rum_ctrl = {
	enable() {
		window.__dd_rum_development = true;
		window.localStorage.setItem("dd_rum_development", "true");
		init();
		console.info("DD RUM: Enabled");
		return true;
	},
	disable() {
		window.__dd_rum_development = false;
		window.localStorage.removeItem("dd_rum_development");
		console.info("DD RUM: Disabled");
		return true;
	},
	status() {
		const { env, shouldRun, envIsOverridden } = getShouldRun();
		const statuses = {
			environment: getEnv(),
			'should run': shouldRun,
			'env overridden': envIsOverridden,
			bootstrapped: !!window.__ddRumBootstrapped,
			initialized: !!window.__ddRumInitialized,
			lastView: window.__ddLastViewName || null,
			'local override': !!window.__dd_rum_development,
			'saved override': window.localStorage.getItem("dd_rum_development"),
		};
		console.table(statuses);
		return statuses;
	},
	track() {
		console.info('track() called');
		willTrack();
    return window.__ddLastViewName || '(no view)';
	},
};